<!-- 资源共享 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/3b32897229e94643a4e6095ec95574d7.png"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <div class="subNavs">
        <div class="in w1200">
          <div
            :class="{
              nav: true,
              active: item.path == $route.path,
            }"
            v-for="item in subNavs"
            :key="item.path"
            @click="changeTab(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="container w1200">
        <sub-title title="价材信息" en="INFORMATION"></sub-title>
        <div class="list" v-if="list.length != 0">
          <div
            class="item"
            v-for="item in list"
            :key="item.id"
            @click="getDetail(item)"
          >
            <div class="point"></div>
            <div class="title">{{ item.fileTitle }}</div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.pageIndex"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <el-empty description="暂无案例" v-else></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [
        {
          title: "政策规范",
          en: "POLICY NORM",
          path: "/files/policy",
        },
        {
          title: "价材信息",
          en: "INFORMATION",
          path: "/files/information",
        },
        {
          title: "指标数据",
          en: "INDEX DATA",
          path: "/files/standard",
        },
      ],
      bannerList: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        dictionaryCode: "24a9e394dbaa42128ac53cbe64c5d079",
      },
      list: [],
      total: 0,
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.routerHistory = [{ path: "/", name: "首页" }, { name: "资源共享" }];
    this.getList();
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 0 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    changeTab(item) {
      this.$router.push(item.path);
    },
    async getList() {
      let res = await this.$api.getFilesList(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    getDetail(item) {
      window.scrollTo({ top: 200 });
      this.$router.push(
        "/files/detail/" + item.id + "?code=" + this.queryParams.dictionaryCode
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    height: 600px;
    object-fit: cover;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/file_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .subNavs {
    text-align: center;
    border-bottom: 1px solid rgb(103 105 105 / 30%);

    .in {
      display: flex;
    }

    .nav {
      flex: 1;
      padding: 10px 0;
      font-size: 20px;
      cursor: pointer;
      border-bottom: 2px solid transparent;

      &:hover {
        color: $theme;
        border-color: $theme;
      }
    }
    .active {
      font-weight: bold;
      color: $theme;
      border-color: $theme;
    }
  }
  .container {
    margin: 70px auto 120px;
  }

  .list {
    margin-top: 50px;

    .item {
      padding: 15px 0;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #9a9a9a;
      color: #5e5d5d;
      cursor: pointer;

      &:hover {
        color: #a01b1b;
      }
      &:first-child {
        border-top: 1px solid #9a9a9a;
      }
      .point {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        background-color: #a01b1b;
        transform: rotate(45deg);
      }
      .title {
        flex-grow: 1;
        margin-left: 10px;
        line-height: 25px;
      }
      i {
        flex-shrink: 0;
        font-size: 16px;
        margin-left: 20px;
      }
    }
  }
}

@media (max-width: 1400px) {
  .frame #banner {
    height: 600px;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .subNavs {
      .in {
        overflow: auto;

        a {
          white-space: nowrap;
        }
        .nav {
          font-size: 16px;
          padding: 10px;
        }
      }
    }
    .list {
      margin-top: 20px;

      .item {
        padding: 10px 0;

        .title {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
